module.exports = __webpack_public_path__ + "static/media/upload-image.306492f0.svg";